import React, { FC } from "react";

export type TProductTechnicalDetailsItem = {
  title: string;
  description: string;
};

export interface IProductTechnicalDetailsProps {
  items: TProductTechnicalDetailsItem[];
}

const ProductTechnicalDetails: FC<IProductTechnicalDetailsProps> = ({
  items,
}) => {
  // Using dt for accessibility
  return (
    <div className="d-flex flex-wrap tech-details">
      {items?.map((item) => (
        <dl key={item.title}>
          <dt className="text-medium">{item.title}</dt>
          <dd className="text-regular">{item.description}</dd>
        </dl>
      ))}
    </div>
  );
};

export default ProductTechnicalDetails;
